import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo6/bandera.png";
import Imagen2 from "../../../images/modulo6/escarapela.png";
import Imagen3 from "../../../images/modulo6/machupicchu.png";
import Imagen4 from "../../../images/modulo6/moneda.png";
import Imagen5 from "../../../images/modulo6/escudo.png";
import Imagen6 from "../../../images/modulo6/mapa.png";
import Imagen7 from "../../../images/modulo6/himno.png";
import Imagen8 from "../../../images/modulo6/totora.png";
import Imagen9 from "../../../images/modulo6/camiseta.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo6 } from "../../../routes/Module6";
import Sidebar from "../Sidebar";
import Card from "../../../components/Card";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo6/Actividad 1.mp3";

const Actividad1 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "0", valid: "", correctValue: "1" },
    ans2: { value: "0", valid: "", correctValue: "0" },
    ans3: { value: "0", valid: "", correctValue: "0" },
    ans4: { value: "0", valid: "", correctValue: "0" },
    ans5: { value: "0", valid: "", correctValue: "1" },
    ans6: { value: "0", valid: "", correctValue: "0" },
    ans7: { value: "0", valid: "", correctValue: "1" },
    ans8: { value: "0", valid: "", correctValue: "0" },
    ans9: { value: "0", valid: "", correctValue: "0" },
  });
  const infoUnidad = modulo6.content[0];
  const infoAct = modulo6.content[0].activities[0];
  const crumbs = [
    {
      title: modulo6.title,
      url: "/" + modulo6.url,
    },
    {
      title:
        modulo6.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo6.content[0].activities[1].name}`,
    linkNext: `${modulo6.url}/${modulo6.content[0].path}/${modulo6.content[0].activities[1].path}`,
    titlePrev: modulo6.title,
    linkPrev: modulo6.url,
  };
  const metadata = {
    color: modulo6.color,
    title: `${modulo6.title} - ${infoAct.name}`,
    name: modulo6.title,
  };
  const handleAnswers = (event, name) => {
    if (answers[name]["value"] === event.target.value) {
      setAnswers({
        ...answers,
        [name]: { ...answers[name], value: "2" },
      });
    } else {
      setAnswers({
        ...answers,
        [name]: { ...answers[name], value: event.target.value },
      });
    }
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"].toUpperCase() ===
          answers[key]["value"].toUpperCase()
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...newAnswers });
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <div className="row">
        <div className="col-lg-10 col-12">
          <p>
            <small className={`c-${modulo6.color} hat-text`}>
              <FontAwesomeIcon icon={faEye} /> Observamos
            </small>
          </p>
          <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

          <ul>
            <li>
              ¿Cuáles de las siguientes imágenes te hacen pensar en el Perú?
              Márcalas con un check
            </li>
          </ul>

          <div className="row align-items-start ms-lg-4 ms-0 mt-2 simbolos-cards g-3">
            <div className="col-lg-4 col-6 text-center">
              <Card>
                <div className="form-check form-check-inline">
                  <input
                    className={
                      "form-check-input mb-1 form-md " + answers.ans1.valid
                    }
                    type="checkbox"
                    value="1"
                    checked={answers.ans1.value === "1"}
                    onChange={(event) => handleAnswers(event, "ans1")}
                  />
                </div>
                <img src={Imagen1} alt="símbolos" className="img-fluid" />
              </Card>
            </div>
            <div className="col-lg-4 col-6 text-center">
              <Card>
                <div className="form-check form-check-inline">
                  <input
                    className={
                      "form-check-input mb-1 form-md " + answers.ans2.valid
                    }
                    type="checkbox"
                    value="1"
                    checked={answers.ans2.value === "1"}
                    onChange={(event) => handleAnswers(event, "ans2")}
                  />
                </div>{" "}
                <img src={Imagen2} alt="símbolos" className="img-fluid" />
              </Card>
            </div>
            <div className="col-lg-4 col-6 text-center">
              <Card>
                <div className="form-check form-check-inline">
                  <input
                    className={
                      "form-check-input mb-1 form-md " + answers.ans3.valid
                    }
                    type="checkbox"
                    value="1"
                    checked={answers.ans3.value === "1"}
                    onChange={(event) => handleAnswers(event, "ans3")}
                  />
                </div>{" "}
                <img src={Imagen3} alt="símbolos" className="img-fluid" />
              </Card>
            </div>
            <div className="col-lg-4 col-6 text-center">
              <Card>
                <div className="form-check form-check-inline">
                  <input
                    className={
                      "form-check-input mb-1 form-md " + answers.ans4.valid
                    }
                    type="checkbox"
                    value="1"
                    checked={answers.ans4.value === "1"}
                    onChange={(event) => handleAnswers(event, "ans4")}
                  />
                </div>{" "}
                <img src={Imagen4} alt="símbolos" className="img-fluid" />
              </Card>
            </div>
            <div className="col-lg-4 col-6 text-center">
              <Card>
                <div className="form-check form-check-inline">
                  <input
                    className={
                      "form-check-input mb-1 form-md " + answers.ans5.valid
                    }
                    type="checkbox"
                    value="1"
                    checked={answers.ans5.value === "1"}
                    onChange={(event) => handleAnswers(event, "ans5")}
                  />
                </div>{" "}
                <img src={Imagen5} alt="símbolos" className="img-fluid" />
              </Card>
            </div>
            <div className="col-lg-4 col-6 text-center">
              <Card>
                <div className="form-check form-check-inline">
                  <input
                    className={
                      "form-check-input mb-1 form-md " + answers.ans6.valid
                    }
                    type="checkbox"
                    value="1"
                    checked={answers.ans6.value === "1"}
                    onChange={(event) => handleAnswers(event, "ans6")}
                  />
                </div>{" "}
                <img src={Imagen6} alt="símbolos" className="img-fluid" />
              </Card>
            </div>
            <div className="col-lg-4 col-6 text-center">
              <Card>
                <div className="form-check form-check-inline">
                  <input
                    className={
                      "form-check-input mb-1 form-md " + answers.ans7.valid
                    }
                    type="checkbox"
                    value="1"
                    checked={answers.ans7.value === "1"}
                    onChange={(event) => handleAnswers(event, "ans7")}
                  />
                </div>{" "}
                <img src={Imagen7} alt="símbolos" className="img-fluid" />
              </Card>
            </div>
            <div className="col-lg-4 col-6 text-center">
              <Card>
                <div className="form-check form-check-inline">
                  <input
                    className={
                      "form-check-input mb-1 form-md " + answers.ans8.valid
                    }
                    type="checkbox"
                    value="1"
                    checked={answers.ans8.value === "1"}
                    onChange={(event) => handleAnswers(event, "ans8")}
                  />
                </div>{" "}
                <img src={Imagen8} alt="símbolos" className="img-fluid" />
              </Card>
            </div>
            <div className="col-lg-4 col-6 text-center">
              <Card>
                <div className="form-check form-check-inline">
                  <input
                    className={
                      "form-check-input mb-1 form-md " + answers.ans9.valid
                    }
                    type="checkbox"
                    value="1"
                    checked={answers.ans9.value === "1"}
                    onChange={(event) => handleAnswers(event, "ans9")}
                  />
                </div>{" "}
                <img src={Imagen9} alt="símbolos" className="img-fluid" />
              </Card>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-10 col-12 mt-5">
        <div className="d-flex w-100 justify-content-end mt-1">
          <button
            className={`btn btn-${modulo6.color}`}
            onClick={validateAnswers}
          >
            Enviar respuestas
          </button>
        </div>
      </div>

      <ul className="mt-5">
        <li>
          Ahora, escribe acá cuáles de las imágenes anteriores son símbolos
          nacionales del Perú.
        </li>
      </ul>
      <textarea className="form-control" rows={3} />

      <GuiaDocente>
        <p>
          Lea la primera indicación. Observen las imágenes e identifíquenlas.
          Luego, conversen sobre lo que marcaron y expliquen por qué esos
          objetos los hacen pensar en el Perú. Ayude a identificar los símbolos
          nacionales oficiales, que son la bandera, el escudo y el himno.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad1;
